import { Injectable } from '@angular/core';

import { RacingConfig } from '@frontend/sports/common/client-config-data-access';
import { SportConstant } from '@frontend/sports/common/core/data-access/constants';
import { BogVersion } from '@frontend/sports/types/configuration/client-configuration';
import { IntlService } from '@frontend/vanilla/core';
import { Store } from '@ngrx/store';
import { ClassicBestOddsGuaranteedService } from 'packages/sports/web/app/src/best-odds-guarantee/services/classic-best-odds-guaranteed.service';
import { FixtureBestOddsGuaranteedTokenValidatorService } from 'packages/sports/web/app/src/best-odds-guarantee/services/fixture-best-odds-guaranteed-token-validator.service';
import { Observable, map, of } from 'rxjs';

import { IBetslipRootState } from '../../../../../base/store/state';
import { BetslipPick } from '../../../../../core/picks/betslip-pick';
import { BetslipV2Pick } from '../../../../../core/picks/betslip-v2-pick';
import { isBOGRacePick } from '../../../../picks/services/betslip-pick-helpers';
import { selectBogTokenContext } from '../../../selectors';
import { convertToBestOddsFixtureLikeInput } from '../../reward-tokens.utils';

@Injectable()
export class BestOddsPickEligibilityValidator {
    constructor(
        private store: Store<IBetslipRootState>,
        private racingConfig: RacingConfig,
        private classicBogValidator: ClassicBestOddsGuaranteedService,
        private fixtureBogValidator: FixtureBestOddsGuaranteedTokenValidatorService,
        private intlService: IntlService,
    ) {}

    isBogEligiblePick$(pick: BetslipPick): Observable<boolean> {
        if (!(BetslipV2Pick.isPick(pick) && isBOGRacePick(pick))) {
            return of(false);
        } else {
            if (
                pick.fixture.sportId === SportConstant.Horses &&
                this.intlService.formatDate(pick.eventDate.toISOString(), 'HH:MM') < this.racingConfig.bogTodayThresholdTime
            ) {
                return of(false);
            }
        }

        const bogFixtureLikeInput = convertToBestOddsFixtureLikeInput(pick);

        switch (this.racingConfig.bogVersion) {
            case BogVersion.TokenBased:
                return this.store.select(selectBogTokenContext).pipe(
                    map((bogContext) => {
                        return bogContext.valid && this.fixtureBogValidator.validate(bogContext.token!, bogFixtureLikeInput);
                    }),
                );
            default:
                return this.classicBogValidator.isFixtureEligible(bogFixtureLikeInput);
        }
    }
}
